/**
 * The phone app's words for notes and activities (piece 35, *Notes and
 * activities (batch CR3)*; decision 4410): Log Contact's form, a note's replies,
 * the author's edit and the Also about chips, spread into the one string lookup
 * beside the earlier batches' words. A word the web already says, such as
 * + Log Contact, Activity kind, Direction, Duration (minutes), Issue flag, None,
 * Save Note, Edit note, Reply, Delete reply or Also about, is read from the web's
 * own key and is not repeated here.
 */
export const CRM_NOTES_STRINGS = {
  'mobile.notes.options.failed': 'The activity kinds and issue flags did not load. Check the connection, then try again.',
  'mobile.notes.minutes.invalid': 'Type the minutes as a whole number.',
  // 🔒 Decision 7180: the phone's editor is plain, so a formatted note's edit keeps its words alone.
  'mobile.notes.edit.plainHint': 'This note carries formatting from the web. Saving it here keeps the words and drops the bold, colors and lists.',
  // 🔨 Decision 8220: said before the person types, where the store keeps no version for the note's record to queue the edit over.
  'mobile.notes.edit.needsSignal': 'This phone keeps no copy of this record, so this change saves only while the phone has a signal.',
  'mobile.notes.edit.unsent': 'The change was not saved, because the server did not answer. Check the connection, then save it again.',
  'mobile.notes.reply.refused': 'The server refused the reply.',
  'mobile.notes.reply.unsent': 'The reply was not sent, because the server did not answer. Check the connection, then send it again.',
  'mobile.notes.reply.notDeleted': 'The reply was not deleted, because the server did not answer. Check the connection, then try again.',
} as const;
